export interface GeoService {
  id: string;
  name: string;
  description: string;
}

export const GEO_SERVICES: GeoService[] = [
  {
    id: 'achat',
    name: 'Accompagnement à l’achat immobilier',
    description: 'Définition des critères et du budget, recherche ciblée, visites, analyse des biens, négociation et suivi jusqu’à la signature.'
  },
  {
    id: 'vente',
    name: 'Vente immobilière',
    description: 'Estimation, valorisation, diffusion de l’annonce, organisation des visites, négociation et suivi administratif de la vente.'
  },
  {
    id: 'location',
    name: 'Location immobilière',
    description: 'Accompagnement des locataires dans leur recherche et des propriétaires dans la mise en location de leur bien.'
  },
  {
    id: 'estimation',
    name: 'Estimation immobilière',
    description: 'Visite du bien, analyse comparative du marché local et remise d’une estimation claire, réaliste et argumentée.'
  }
];
